import {combineReducers} from 'redux';
import user from './user';
import users from './users';
import accidents from './accidents';
import reports from './reports';
import departments from './departments';
import progress from './progress-bar';

export default combineReducers({
    user,
    users,
    accidents,
    reports,
    departments,
    progress,
});